// extracted by mini-css-extract-plugin
module.exports = {"wrap":"mbMkVylCoQVVqlVdfK1Nw","label":"PgNtm7NmEf8FwtvMG9Gtt","arrow":"_285KuyJ_4NtTf7T9h7mmbt"};